import React, { useState, useEffect, useRef } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel,
	FormLabel,
	FormControl,
	InputLabel,
	Select,
	ListItemText,
	Input
} from "@mui/material";
// import FormLabel from "@mui/material/FormLabel";
import SearchIcon from "@mui/icons-material/Search";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { adminGetIntegrationTypeList } from "../../redux/actions/adminGetIntegrationTypeListAction";
import { adminGetIntegrationList } from "../../redux/actions/adminGetIntegrationListAction";
import {
	adminDeleteIntegration,
	resetAdminDeleteIntegration
} from "../../redux/actions/adminDeleteIntegrationAction";
import {
	adminAddIntegration,
	resetAdminAddIntegration
} from "../../redux/actions/adminAddIntegrationAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
// import Tooltip from "@mui/material/Tooltip";
import BackButton from "../../components/BackButton/BackButton";
import { AiOutlineSearch } from "react-icons/ai";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
// 	createFilterOptions,
// } from "@mui/material/lab/Autocomplete";
import { getWayList } from "../../redux/actions/getWayListAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminGetCountryList } from '../../redux/actions/adminGetCountryList';
import val from "../../getThemeDetails";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminGatewayManagement = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [searchWalletOwnerId, setSearchWalletOwnerId] = useState("");
	const [searchCurrency, setSearchCurrency] = useState("");
	const [searchIntegrationName, setSearchIntegrationName] = useState("");
	const [searchIntegrationType, setSearchIntegrationType] = useState("");
	const [deleteAcc, setDeleteAcc] = useState("");
	const [page, setPage] = useState(0);
	const [Open, setOpen] = React.useState(false);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);
	const [getIntegrationTypeStatus, setGetIntegrationTypeStatus] =
		useState(false);
	const [getIntegrationTypeArray, setGetIntegrationTypeArray] = useState([]);
	const [getIntegrationListStatus, setGetIntegrationListStatus] =
		useState(false);
	const [getIntegrationListArray, setGetIntegrationListArray] = useState([]);
	const [deleteIntegrationStatus, setDeleteIntegrationStatus] = useState(false);
	const [deleteIntegrationArray, setDeleteIntegrationArray] = useState([]);

	const [addOrUpdateIntegrationStatus, setAddOrUpdateIntegrationStatus] =
		useState(false);
	const [addOrUpdateIntegrationArray, setAddOrUpdateIntegrationArray] =
		useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [countries, setCountries] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [currencies, setCurrencies] = useState([]);

	const [notificationDeleteOpen, setNotificationDeleteOpen] =
		React.useState(false);

	const [showIntegrationName, setShowIntegrationName] = useState([])
	const pendingCountryISO = useRef('');

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const classes = useStyles();
	const dispatch = useDispatch();

	var view = "view";
	var edit = "edit";
	// const [modalIntegrationName, setModalIntegrationName] = useState('')
	const [user, setUser] = useState({
		accountId: "",
		walletOwnerID: "",
		integrationType: "",
		integrationName: "",
		memberUserName: "",
		memberID: "",
		memberSecretKey: "",
		currency: "",
		partnerID: "",
		terminalID: "",
		toType: "",
		redirectURL: "",
		paymentType: "",
		paymentBrand: "",
		paymentMode: "",
		transactionURL: "",
		checkOutTransactionURL: "",
		withDrawURL: "",
		authTokenURL: "",
		partnerKey: "",
		partnerUserName: "",
		integration: "",
		depositeURL: "",
		isActive: "",
		refundURL: "",
		isRefund: "",
		isTest: "",
		isAddress: "",
		countries: []
	});

	const {
		accountId,
		walletOwnerID,
		integrationType,
		integrationName,
		memberUserName,
		memberID,
		memberSecretKey,
		currency,
		partnerID,
		terminalID,
		toType,
		redirectURL,
		paymentType,
		paymentBrand,
		paymentMode,
		transactionURL,
		checkOutTransactionURL,
		withDrawURL,
		authTokenURL,
		partnerKey,
		partnerUserName,
		integration,
		depositeURL,
		refundURL,
		isActive,
		isRefund,
		isTest,
		isAddress,

	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });

		// setUser({ ...user, [name]: value })

		const obj = {
			...user
		};

		if (name === "integrationType" || name === "isActive" ||
			name === "isRefund" || name === "isTest" || name === "isAddress" ||
			name === "integration") {
			obj[name] = value;
			setUser(obj);
			return;
		}
		// if (name === "integrationName") {
		// 	setUser({ ...user, [name]: showIntegrationName[value].integrationName })
		// 	// setModalIntegrationName(showIntegrationName[value].integrationName)
		// 	return
		// }

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else if (type == "url") {
			obj[name] = Util.verifyUrl(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		// console.log("OBJJJJ", obj)

		setUser(obj);

	};

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getIntegrationTypeListRes = useSelector(
		({ adminGetIntegrationType }) => adminGetIntegrationType
	);

	const getIntegrationListRes = useSelector(
		({ adminGetIntegrationList }) => adminGetIntegrationList
	);

	const deleteIntegrationRes = useSelector(
		({ adminDeleteIntegration }) => adminDeleteIntegration
	);
	const loginData = useSelector(({ login }) => login);

	const addIntegrationRes = useSelector(
		({ adminAddIntegration }) => adminAddIntegration
	);

	const handleNoticationClose = () => {
		setSearchWalletOwnerId("");
		setNotificationOpen(false);
		setNotificationDeleteOpen(false);
	};

	const handleChangeIntegrationType = (event) => {
		// console.log("INTEGRATION NAME", event.target.value)
		if (event.target.name === "integrationType") {
			setUser({ ...user, [event.target.name]: event.target.value })
			getIntegrationListReqModal(event.target.value);

		}
	}
	// console.log("getWayListResMoye", getIntegrationListRes)

	useEffect(() => {
		// console.log("getWayListRes!!!!", getIntegrationListRes.data.integrationMasterDetailsList)
		if (getIntegrationListRes.data.integrationMasterDetailsList) {
			setShowIntegrationName([].concat(getIntegrationListRes.data.integrationMasterDetailsList))
		}
	}, [getIntegrationListRes])
	const handleChange = ({ target: { name, value } }) => {
		if (name === "searchWalletOwnerId") {
			setSearchWalletOwnerId(value);
		}
		if (name === "searchCurrency") {
			setSearchCurrency(value == "All" ? "" : value);
		}
		if (name === "searchIntegrationName") {
			// setSearchIntegrationName(value);
			Util.verifyAlphabet(value.integrationName)
				? setSearchIntegrationName(value.integrationName)
				: setSearchIntegrationName(searchIntegrationName);
		}
		if (name === "searchIntegrationType") {
			setSearchIntegrationType(value == "All" ? "" : value);
		}


		// console.log('searchIntegrationName: ', searchIntegrationName);
	};

	const getIntegrationTypeListReq = () => {
		setGetIntegrationTypeStatus(true);
		const req = {
			ownerMasterRequestVO: {
				adminId: val.adminIDS
			}
		};
		dispatch(
			adminGetIntegrationTypeList(req, regenerateTokenRes.data.AuthToken)
		);
	};

	// useEffect(() => {
	//   if (regenerateTokenRes.data.status == "success") {
	//     getIntegrationTypeListReq();
	//   }

	// }, [regenerateTokenRes.data.status]);

	const getIntegrationTypeListFunc = () => {
		if (getIntegrationTypeStatus) {
			if (getIntegrationTypeListRes.data.status == "success") {
				setGetIntegrationTypeArray(
					[].concat(getIntegrationTypeListRes.data.integrationTypeList)
				);
			}
			if (getIntegrationTypeListRes.data.status == "failed") {
				setGetIntegrationTypeArray(getIntegrationTypeListRes.data);
				if (
					getIntegrationTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getIntegrationTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getIntegrationTypeListFunc();
	}, [getIntegrationTypeListRes.data.status]);

	const getIntegrationListReqModal = (InteGrationType) => {
		// console.log("INTEGRATIONTYPEEE", InteGrationType)
		setIsLoading(true);
		setGetIntegrationListStatus(true);
		let req = {
			ownerMasterRequestVO: {
				adminId: val.adminIDS,
				ownerID: loginData.data.partnerId,
				// searchWalletOwnerId == "Select Owner Id"
				//   ? ""
				//   : searchWalletOwnerId.split("-")[0],
				currency: searchCurrency,
				integrationName: searchIntegrationName,
				integrationType: InteGrationType
			}

		};
		// console.log("REQUESTTTTTTT", req)
		dispatch(adminGetIntegrationList(req, authToken));
		setSearchIntegrationType('')
	};

	const getIntegrationListReq = () => {
		setIsLoading(true);
		setGetIntegrationListStatus(true);
		let req = {
			ownerMasterRequestVO: {
				adminId: val.adminIDS,
				ownerID: loginData.data.partnerId,
				// searchWalletOwnerId == "Select Owner Id"
				//   ? ""
				//   : searchWalletOwnerId.split("-")[0],
				currency: searchCurrency,
				integrationName: searchIntegrationName,
				integrationType: searchIntegrationType
			}
		};
		dispatch(adminGetIntegrationList(req, authToken));
		setSearchIntegrationType('')
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getIntegrationListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getIntegrationListFunc = () => {
		if (getIntegrationListStatus) {
			if (getIntegrationListRes.data.status == "success") {
				setIsLoading(false);
				setGetIntegrationListArray(
					[].concat(getIntegrationListRes.data.integrationMasterDetailsList)
				);
			}
			if (getIntegrationListRes.data.status == "failed") {
				setIsLoading(false);
				setGetIntegrationListArray(getIntegrationListRes.data);
				if (
					getIntegrationListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getIntegrationListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getIntegrationListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setGetIntegrationListArray(getIntegrationListRes.data);
				setGetIntegrationListStatus(false);
			}
		}
	};

	useEffect(() => {
		getIntegrationListFunc();
	}, [getIntegrationListRes.data.status]);

	useEffect(() => {
		if (getIntegrationListRes.data.status == "success") {
			setPage(0);
		}
	}, [getIntegrationListRes.data.status]);

	const deleteIntegration = () => {
		setOpen(false);
		setViewOpen(false);
		setEditOpen(false);
		setAddOpen(false);
		setDeleteIntegrationStatus(true);

		let req = {
			accountId: deleteAcc,
			walletOwnerId: regenerateTokenRes.data.partnerId
		};
		dispatch(adminDeleteIntegration(req, authToken));
	};

	const deleteIntegrationResFunc = () => {
		if (deleteIntegrationStatus) {
			if (deleteIntegrationRes.data.status == "success") {
				setOpen(false);
				setEditOpen(false);
				// setNotificationOpen(true);
				setNotificationDeleteOpen(true);
				setDeleteIntegrationArray(deleteIntegrationRes.data);
				// if(notificationOpen){
				// }
				getIntegrationListReq();
			}
			if (deleteIntegrationRes.data.status == "failed") {
				dispatch(resetAdminAddIntegration());
				setDeleteIntegrationArray(deleteIntegrationRes.data);
				setNotificationOpen(true);
				if (
					deleteIntegrationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteIntegrationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		if (deleteIntegrationRes.data.status == "success") {
			deleteIntegrationResFunc();
		}
	}, [deleteIntegrationRes.data.status]);

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						// adminId: "2"
						adminId: val.adminIDS
					}
				},
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameListReq();
			getIntegrationTypeListReq();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(parseInt(event.target.value, 10));
	// 	setPage(0);
	// };

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		const currentFirstRowIndex = page * rowsPerPage;
		const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

		setRowsPerPage(newRowsPerPage);
		setPage(newPage);
	};

	const handleClose = () => {
		setUser({
			integrationType: "",
			integrationName: "",
			memberUserName: "",
			memberID: "",
			memberSecretKey: "",
			currency: "",
			partnerID: "",
			terminalID: "",
			toType: "",
			redirectURL: "",
			paymentType: "",
			paymentBrand: "",
			paymentMode: "",
			transactionURL: "",
			checkOutTransactionURL: "",
			withDrawURL: "",
			authTokenURL: "",
			partnerKey: "",
			partnerUserName: "",
			integration: "",
			depositeURL: "",
			isActive: "",
			refundURL: ""
		});
		pendingCountryISO.current = ''; // ✅ Clear ref on close
		setOpen(false);
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setCountries([]); // Add this
		setCurrencies([]); // ← add this
		// setCountryList([]); // Add this

	};

	const deleteIntegrationFunc = (value) => {
		setDeleteAcc(value);
		setEditOpen(false);
		setOpen(true);
	};

	// Same API for add and update

	const addOrUpdateIntegrationReq = () => {
		setAddOrUpdateIntegrationStatus(true);
		setEditOpen(false);
		setAddOpen(false);
		let req = {
			accountId: accountId,
			//ownerName: walletOwnerID.split("-")[0],//walletOwnerID == "Select Owner Id" ? "" : walletOwnerID.split("-")[0],
			ownerName:
				// walletOwnerID == "Select Owner Id" ? "" : walletOwnerID.split("-")[0],
				loginData.data.partnerId,
			integrationType: integrationType,
			integrationName: integrationName,
			memPass: memberUserName,
			memId: memberID,
			memSecKey: memberSecretKey,
			curr: currency,
			partId: partnerID,
			terminalId: terminalID,
			toType: toType,
			redirectUrl: redirectURL,
			payType: paymentType,
			payBrand: paymentBrand,
			payMode: paymentMode,
			transacUrl: transactionURL,
			checkOutTransacUrl: checkOutTransactionURL,
			withdrawUrl: withDrawURL,
			authUrl: authTokenURL,
			partKey: partnerKey,
			partUserName: partnerUserName,
			integrationValues: integration,
			depositeUrl: depositeURL,
			isActive: isActive,
			refundUrl: refundURL,
			isRefund: isRefund,
			isTest: isTest,
			isAddressRequired: isAddress,
			countrySupported: countries.length === 0 ? '' : getCountryIsoCodes(countryList, countries), // Changed to countryIso
			curr: currencies.join(','),
		};
		dispatch(adminAddIntegration(req, authToken));
		// console.log('adminAddIntegration: ',req);
	};

	const addOrUpdateIntegrationFunc = () => {
		if (addOrUpdateIntegrationStatus) {
			if (addIntegrationRes.data.status == "success") {
				setAddOrUpdateIntegrationArray(addIntegrationRes.data);
				setNotificationOpen(true);
				getIntegrationListReq();
			}
			if (addIntegrationRes.data.status == "failed") {
				setAddOrUpdateIntegrationArray(addIntegrationRes.data);
				setNotificationOpen(true);
				if (
					addIntegrationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addIntegrationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateIntegrationFunc();
	}, [addIntegrationRes.data.status]);

	const setData = (row, fs) => {
		setUser({
			accountId: row.accountId,
			walletOwnerID: row.ownerName,
			integrationType: row.integrationType,
			integrationName: row.integrationName,
			memberUserName: row.memPass,
			memberID: row.memId,
			memberSecretKey: row.memSecKey,
			currency: row.curr,
			partnerID: row.partId,
			terminalID: row.terminalId,
			toType: row.toType,
			redirectURL: row.redirectUrl,
			paymentType: row.payType,
			paymentBrand: row.payBrand,
			paymentMode: row.payMode,
			transactionURL: row.transacUrl,
			checkOutTransactionURL: row.checkOutTransacUrl,
			withDrawURL: row.withdrawUrl,
			authTokenURL: row.authUrl,
			partnerKey: row.partKey,
			partnerUserName: row.partUserName,
			integration: row.integrationValues,
			depositeURL: row.depositeUrl,
			refundURL: row.refundUrl,
			isActive: row.isActive,
			isRefund: row.isRefund || "",
			isTest: row.isTest || "",
			isAddress: row.isAddressRequired || "",
			countrySupported: row.countrySupport || "", // <-- take `GB|BD 
		});

		// ✅ Store raw ISO string in ref immediately (no closure issues)
		pendingCountryISO.current = row.countrySupport || '';


		// ✅ Reset countries so stale values don't show
		setCountries([]);

		// ✅ Always call with reliable fallback
		getCountryListReq(row.partId || row.ownerId || loginData.data.partnerId)

		// Fetch country list for the owner first
		// if (row.partId || row.ownerId) {
		// 	getCountryListReq(row.partId || row.ownerId);
		// }

		// Pre-populate currencies (if stored as "USD,EUR" or "USD|EUR")
		if (row.curr) {
			setCurrencies(row.curr.split(/[,|]/)); // splits by comma or pipe
		} else {
			setCurrencies([]);
		}



		// Set countries if they exist in the row
		// Assuming the API returns country names or you need to convert country ISO to names
		// if (row.countryIso && Array.isArray(row.countryIso)) {
		// 	// If row.countryIso contains ISO codes, you might need to map them to names
		// 	// For now, assuming it contains country names
		// 	setCountries(row.countryIso);
		// } else if (row.countries && Array.isArray(row.countries)) {
		// 	setCountries(row.countries);
		// }
		// else if (row.countrySupport) {
		// 	// Convert "GB|BD" → ["GB","BD"]
		// 	const isoArray = row.countrySupport.split('|');

		// 	// Map ISO to country names using existing function
		// 	const mappedNames = mapIsoToCountryNames(isoArray, countryList);

		// 	setCountries(mappedNames);  // <--- this sets preselected values
		// }
		// else {
		// 	// setCountries([]);
		// }
		if (fs == "view") {
			setEditOpen(false);
			setNotificationOpen(false);
			setViewOpen(true);
		}
		if (fs == "edit") {
			setNotificationOpen(false);
			setViewOpen(false);
			setEditOpen(true);
		}
	};

	const addRole = (e) => {
		setSearchIntegrationName("")
		setUser({
			accountId: "",
			walletOwnerID: "",
			integrationType: "",
			integrationName: "",
			memberUserName: "",
			memberID: "",
			memberSecretKey: "",
			currency: "",
			partnerID: "",
			terminalID: "",
			toType: "",
			redirectURL: "",
			paymentType: "",
			paymentBrand: "",
			paymentMode: "",
			transactionURL: "",
			checkOutTransactionURL: "",
			withDrawURL: "",
			authTokenURL: "",
			partnerKey: "",
			partnerUserName: "",
			integration: "",
			depositeURL: "",
			isActive: "",
			refundURL: ""
		});
		setNotificationOpen(false);
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(true);
		// 🔥 Fetch country list immediately
		getCountryListReq(loginData.data.partnerId);
		setCurrencies([]); // ← add this
	};

	const filterOptions = createFilterOptions({
		matchFrom: "any",
		limit: 500,
	});

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			// console.log('regenerateTokenRes.data.status: ', regenerateTokenRes.data.status);
			const getWayListReq = {
				walletOwnerId: 1,
				paymentBrand: '',
				paymentMode: ''
			};
			dispatch(getWayList(getWayListReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const getWayListRes = useSelector(({ getWayList }) => getWayList);
	console.log("getWayListRes", getWayListRes)

	const getCountryListRes = useSelector(({ getCountryList }) => getCountryList);

	const getCountryIsoCodes = (countryListArray, selectedCountries) => {
		let countryIsoCodes = [];
		let countryNameMap = countryListArray.map(x => x.countryName);
		for (let i = 0; i < selectedCountries.length; i++) {
			countryIsoCodes.push(countryListArray[countryNameMap.indexOf(selectedCountries[i])].countryIso);
		}
		return countryIsoCodes;
	};

	const mapIsoToCountryNames = (countryIsoArray, countryListArray) => {
		if (!countryIsoArray || !Array.isArray(countryIsoArray) || countryListArray.length === 0) return [];
		return countryIsoArray.map(iso => {
			const country = countryListArray.find(c => c.countryIso === iso);
			return country ? country.countryName : null;
		}).filter(name => name !== null);
	};




	const getCountryListReq = (walletOwnerId) => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: walletOwnerId,
				country: "",
				countryCode: "",
				countryIso: ""
			}
		}
		dispatch(adminGetCountryList(req, authToken));


	};

	useEffect(() => {
		if (getCountryListRes.data.status === 'success') {
			setCountryList(getCountryListRes.data.customerMasterDetailsRequestVOList || []);
		}
	}, [getCountryListRes.data.status]);

	useEffect(() => {
		if ((editOpen || viewOpen) && countryList.length > 0) {
			// If we have stored countryIso in user state, map them to names
			// if (user.countryIso && Array.isArray(user.countryIso)) {
			// 	const countryNames = mapIsoToCountryNames(user.countryIso, countryList);
			// 	setCountries(countryNames);
			// } else if (user.countrySupport) {
			// 	const isoArray = user.countrySupport.split('|');
			// 	const mappedNames = mapIsoToCountryNames(isoArray, countryList)
			// 	if (mappedNames.length > 0) {
			// 		setCountries(mappedNames);
			// 	}
			// }
			// ✅ Read from ref — never stale, no closure issues
			if (pendingCountryISO.current) {
				const isoArray = pendingCountryISO.current.split('|').filter(Boolean);
				const mappedNames = mapIsoToCountryNames(isoArray, countryList);
				if (mappedNames.length > 0) {
					setCountries(mappedNames);
				}
			}
		}
	}, [countryList, editOpen, viewOpen]);
	// console.log('getWayListRes: ', getWayListRes);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					{/* <DialogTitle>Integration Master</DialogTitle> */}
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem"
						}}
					>
						<Grid item md={4} sm={12} lg={9}></Grid>
						<Grid item md={4} sm={12} lg={3}>
							{/* <NavLink to="/index/addIntegration"> */}
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addRole()}
							>
								Add New Integration
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addRole()}
							>
								Add New Integration
							</CustomButton>
							{/* </NavLink> */}
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ padding: "25px", gap: "10px" }}>
						{/* <Grid item sm={12} md={3} lg={3}>
              <TextField

                size="small"
                color="primary"
                type="text"
                label="Wallet Owner ID"
                fullWidth={true}
                name="searchWalletOwnerId"
                // defaultValue={"Select Owner Id" || searchWalletOwnerId}
                onChange={handleChange}
                value={searchWalletOwnerId}
              >
                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                  Select Owner Id
                </MenuItem>
                {getWalletOwnerIdRes.data.ownerList &&
                  getWalletOwnerIdResArray.map((x) => (
                    <MenuItem value={x}>{x}</MenuItem>
                    // <MenuItem value={x.replace(/[0-9]/g, "").replace("-", "")}>
                    //   {x.replace(/[0-9]/g, "").replace("-", "")}
                    // </MenuItem>
                  ))}
              </TextField>
            </Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="searchCurrency"
								defaultValue={"All" || searchCurrency}
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="All" selected="All	">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Integration Name"
								fullWidth
								name="searchIntegrationName"
								// value={searchIntegrationName || ""}
								defaultValue={"All" || searchIntegrationName}
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							>
								<MenuItem value="All" selected="All	">
									Select Integration Name
								</MenuItem>
								{getWayListRes.success &&
									[]
										.concat(getWayListRes.data.gatewayRequestVOList)
										.map((x) => <MenuItem value={x}>{x.gatewayId + '-' + x.memberUserName +'-' +  x.memberId  + '-' + x.currency}</MenuItem>)}
							</TextField>
							{/* main */}
							{/* <TextField
								size="small"
								color="primary"
								type="text"
								label="Integration Name"
								fullWidth={true}
								name="searchIntegrationName"
								value={searchIntegrationName || ""}
								onChange={handleChange}
							></TextField> */}
							{/* autocomplete */}
							{/* <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getWayListRes.data.gatewayRequestVOList || [""]
                                )}
                                getOptionLabel={(user) => `${user.gatewayId}-${user.integrationName}-${user.currency}`}
                                filterOptions={filterOptions}
                                renderInput={(params) => (
                                    <TextField
										size="small"
										color="primary"
                                        label="Integration Name"
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={searchIntegrationName || ''}
                                        name="searchIntegrationName"
                                        onChange={handleChange}
                                    />
                                )}
                            /> */}
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Integration Type"
								fullWidth={true}
								name="searchIntegrationType"
								defaultValue={"All" || searchIntegrationType}
								onChange={handleChange}
								placeholder="Please Select Currency"
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							>
								<MenuItem value="All" selected="All">
									Select Integration Type
								</MenuItem>
								{getIntegrationTypeListRes.data.integrationTypeList &&
									getIntegrationTypeArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={2} lg={2}>
							{/* <Button
								style={{
									// marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white"
									// marginTop: "15px",
								}}
								variant="contained"
								onClick={getIntegrationListReq}
								endIcon={<AiOutlineSearch />}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getIntegrationListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getIntegrationListArray.length == undefined ||
					!getIntegrationListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Integration Master
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Gateway Managements
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Sr.No
                      </TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Gateway ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Owner Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Payment Mode
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Payment Brand
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Integration Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												MID Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												MID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getIntegrationListArray &&
											[]
												.concat(getIntegrationListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														{/* <TableCell align="center">{index + 1}</TableCell> */}
														<TableCell align="center">
															{row.accountId}
														</TableCell>
														<TableCell align="center">
															{row.ownerName}
														</TableCell>
														<TableCell align="center">{row.payMode}</TableCell>
														<TableCell align="center">{row.payBrand}</TableCell>
														<TableCell align="center">
															{row.integrationType}
														</TableCell>
														<TableCell align="center">{row.memPass}</TableCell>
														<TableCell align="center">{row.memId}</TableCell>
														<TableCell align="center"
															style={{ wordBreak: "break-word", whiteSpace: "normal" }}
														>{row.curr}</TableCell>
														<TableCell
															align="center"
															style={{ display: "flex" }}
														>
															{/* <Tooltip title="View"> */}
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, view)}
															>
																{
																	<VisibilityIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
															{/* </Tooltip> */}

															{/* <Tooltip title="Edit"> */}
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																{
																	<EditIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
															{/* </Tooltip> */}

															{/* <Tooltip title="Delete"> */}
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	deleteIntegrationFunc(row.accountId)
																}
															>
																{
																	<DeleteIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
															{/* </Tooltip> */}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getIntegrationListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={Open} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure you want to delete?</DialogTitle>
						<DialogActions className="p-3">
							<CustomButton
								// style={{
								// 	backgroundColor: "#fff",
								// 	color: "#000"
								// }}

								onClick={handleClose}
							>
								No
							</CustomButton>
							<CustomButton
								// style={{
								// 	padding: "8px"
								// }}
								onClick={deleteIntegration}
							>
								Yes
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			<div>
				<Dialog open={addOpen} onClose={handleClose}>
					<DialogTitle>Add Integration</DialogTitle>
					<DialogContent>
						{/* <TextField
              required
              select
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Wallet Owner ID"
              fullWidth={true}
              name="walletOwnerID"
              defaultValue={"Select Owner Id" || walletOwnerID}
              onChange={(e) => onInputChange(e)}
            >
              <MenuItem value="Select Owner Id" selected="Select Owner Id">
                Select Owner Id
              </MenuItem>
              {getWalletOwnerIdRes.data.ownerList &&
                getWalletOwnerIdResArray.map((x) => (
                  <MenuItem value={x}>{x}</MenuItem>
                  // <MenuItem value={x.replace(/[0-9]/g, "").replace("-", "")}>
                  //   {x.replace(/[0-9]/g, "").replace("-", "")}
                  // </MenuItem>
                ))}
            </TextField> */}

						<TextField
							// required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Integration Type"
							fullWidth={true}
							name="integrationType"
							defaultValue={"All" || integrationType}
							// onChange={(e) => onInputChange(e)}
							onChange={handleChangeIntegrationType}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="All" selected="All">
								Select Integration Type
							</MenuItem>
							{/* {console.log("getIntegrationTypeListRessssss12", getIntegrationTypeListRes)} */}
							{/* {getIntegrationTypeListRes.data.integrationTypeList &&
								getIntegrationTypeArray.map((x) => (
									<MenuItem value={x.replace(/_/g, " ")}>
										{x.replace(/_/g, " ")}
									</MenuItem>
								))} */}
							{getIntegrationTypeListRes.data.integrationTypeList &&
								getIntegrationTypeArray.map((x) => (
									<MenuItem value={x}>{x}</MenuItem>
								))}
						</TextField>
						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Integration Name"
							fullWidth={true}
							name="integrationName"
							variant="standard"
							value={integrationName || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						{/* <TextField
							select
							required
							size="small"
							color="primary"
							type="text"
							label="Integration Names"
							fullWidth
							name="integrationName"
							variant="standard"
							// defaultValue={"All" || modalIntegrationName}
							value={modalIntegrationName || "All"}
							onChange={(e) => onInputChange(e)}
						> */}
						{/* <MenuItem value="All" selected="All	">
								Select Integration Name
							</MenuItem>
							{console.log("getWayListRes7777", getWayListRes)}
							{showIntegrationName.map((x, i) => <MenuItem value={i}>{x.accountId + '-' + x.integrationName + '-' + x.curr + '-' + x.payBrand + '-' + x.payMode}</MenuItem>)} */}
						{/* </TextField>  */}
						{/* <TextField
							select
							required
							size="small"
							color="primary"
							type="text"
							label="Integration Name"
							fullWidth
							name="integrationName"
							// defaultValue={"All" || modalIntegrationName}
							// value={modalIntegrationName || "All"}
							onChange={(e) => onInputChange(e)}
							variant="standard"

						>
							<MenuItem value="All" selected="All	">
								Select Integration Name
							</MenuItem> */}
						{/* {console.log("getWayListRes7777", getWayListRes)} */}
						{/* {showIntegrationName.map((x, i) => <MenuItem value={i}>{x.accountId + '-' + x.integrationName + '-' + x.curr + '-' + x.payBrand + '-' + x.payMode}</MenuItem>)}
						</TextField> */}

						{/* <TextField
							required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Currency"
							fullWidth={true}
							name="currency"
							defaultValue={"All" || currency}
							onChange={(e) => onInputChange(e)}
						>
							<MenuItem value="All" selected="All">
								Select Currency
							</MenuItem>
							{adminCurrencyList.success &&
								[]
									.concat(adminCurrencyList.data.currencyList)
									.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
						</TextField> */}

						{/* <TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Integration Name"
							fullWidth={true}
							name="integrationName"
							value={integrationName || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
						></TextField> */}

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member User Name/Number"
							fullWidth={true}
							name="memberUserName"
							value={memberUserName || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member ID/SID"
							fullWidth={true}
							name="memberID"
							value={memberID || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "number")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member Secret Key"
							fullWidth={true}
							name="memberSecretKey"
							value={memberSecretKey || ""}
							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						{/* <TextField
							// required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Currency"
							fullWidth={true}
							name="currency"
							defaultValue={"All" || currency}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						>
							<MenuItem value="All" selected="All">
								Select Currency
							</MenuItem>
							{adminCurrencyList.success &&
								[]
									.concat(adminCurrencyList.data.currencyList)
									.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
						</TextField> */}

						<Grid item xs={12} sm={12} md={12} lg={12}>
							<FormControl style={{ width: '100%', marginTop: '10px' }}>
								<InputLabel id='multipleCurrencySelect' sx={{ color: 'gray' }}>
									Select Currency
								</InputLabel>
								<Select
									labelId='multipleCurrencySelect'
									multiple
									fullWidth={true}
									variant='standard'
									value={currencies || []}
									input={<Input />}
									renderValue={selected => selected.join(', ')}
									onChange={(e) => {
										const value = e.target.value;
										if (value.includes('all')) {
											const allCurrencies = adminCurrencyList.success
												? [].concat(adminCurrencyList.data.currencyList)
												: [];
											setCurrencies(
												currencies.length === allCurrencies.length
													? []
													: allCurrencies
											);
										} else {
											setCurrencies(value);
										}
									}}
									name='currencies'
									sx={{
										"&:before": { borderBottomColor: "gray" },
										"&:after": { borderBottomColor: "gray" },
									}}
								>
									<MenuItem key='all' value='all'>
										<Checkbox color='primary'
											checked={
												adminCurrencyList.success &&
												currencies.length === [].concat(adminCurrencyList.data.currencyList).length
											}
										/>
										<ListItemText primary='Select All' />
									</MenuItem>
									{adminCurrencyList.success &&
										[].concat(adminCurrencyList.data.currencyList).map((x, index) => (
											<MenuItem key={index} value={x}>
												<Checkbox color='primary'
													checked={currencies.indexOf(x) > -1} />
												<ListItemText primary={x} />
											</MenuItem>
										))
									}
								</Select>
							</FormControl>
						</Grid>
						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner ID"
							fullWidth={true}
							name="partnerID"
							value={partnerID || ""}
							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "number")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Terminal ID"
							fullWidth={true}
							name="terminalID"
							value={terminalID || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "number")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="To Type"
							fullWidth={true}
							name="toType"
							value={toType || ""}
							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Redirect URL"
							fullWidth={true}
							name="redirectURL"
							value={redirectURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Type"
							fullWidth={true}
							name="paymentType"
							value={paymentType || ""}
							//onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Brand"
							fullWidth={true}
							name="paymentBrand"
							value={paymentBrand || ""}
							//onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Mode"
							fullWidth={true}
							name="paymentMode"
							value={paymentMode || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>
						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Transaction URL"
							fullWidth={true}
							name="transactionURL"
							value={transactionURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						//onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="CheckOut Transaction URL"
							fullWidth={true}
							name="checkOutTransactionURL"
							value={checkOutTransactionURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="WithDraw URL"
							fullWidth={true}
							name="withDrawURL"
							value={withDrawURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="AuthToken URL"
							fullWidth={true}
							name="authTokenURL"
							value={authTokenURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Deposit URL"
							fullWidth={true}
							name="depositeURL"
							value={depositeURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>


						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Refund URL"
							fullWidth={true}
							name="refundURL"
							value={refundURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner Key"
							fullWidth={true}
							name="partnerKey"
							value={partnerKey || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner User Name"
							fullWidth={true}
							name="partnerUserName"
							value={partnerUserName || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
						></TextField>

						<TextField
							select
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
               Is Active"
							fullWidth
							name="isActive"
							value={isActive || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>
						{/* After isActive TextField in ADD dialog */}
						<TextField
							select
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"
							label="Is Refund"
							fullWidth
							name="isRefund"
							value={isRefund || ""}
							onChange={(e) => onInputChange(e, "both")}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' },
							}}
						>
							<MenuItem value="Auto">Auto</MenuItem>
							<MenuItem value="Manual">Manual</MenuItem>
						</TextField>

						<TextField
							select
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="Is Test"
							fullWidth
							name="isTest"
							value={isTest || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>

						<TextField
							select
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="Is Address"
							fullWidth
							name="isAddress"
							value={isAddress || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<FormControl style={{ width: '100%', marginTop: '10px' }}>
								<InputLabel id='multipleCountrySelect' sx={{ color: 'gray' }}>
									Select Countries
								</InputLabel>
								<Select
									labelId='multipleCountrySelect'
									multiple
									fullWidth={true}
									variant='standard'
									value={countries || []}
									input={<Input />}
									renderValue={selected => selected.join(', ')}
									onChange={(e) => {
										const value = e.target.value;
										if (value.includes('all')) {
											setCountries(
												countries.length === countryList.filter(ch => !ch.disabled).length
													? []
													: countryList.filter(ch => !ch.disabled).map(x => x.countryName)
											);
										} else {
											setCountries(value);
										}
									}}
									name='countries'
									sx={{
										"&:before": { borderBottomColor: "gray" },
										"&:after": { borderBottomColor: "gray" },
									}}
								>
									<MenuItem key='all' value='all'>
										<Checkbox color='primary'
											checked={countries.length === countryList.filter(ch => !ch.disabled).length} />
										<ListItemText primary='Select All' />
									</MenuItem>
									{countryList &&
										[].concat(countryList).map((x, index) => {
											return (
												<MenuItem key={index}
													disabled={x.disabled}
													value={`${x.countryName}`}>
													<Checkbox color='primary'
														checked={countries.indexOf(`${x.countryName}`) > -1} />
													<ListItemText primary={x.countryName} />
												</MenuItem>
											)
										})
									}
								</Select>
							</FormControl>
						</Grid>



						<FormLabel style={{ marginBottom: "0", marginTop: "12px" }}>
							Integration
						</FormLabel>
						<RadioGroup
							required
							row
							name="integration"
							value={integration || ""}
							onChange={(e) => onInputChange(e)}
						>
							<FormControlLabel
								value="api"
								control={<Radio color="primary" />}
								label="Api"
							/>
							<FormControlLabel
								value="checkout"
								control={<Radio color="primary" />}
								label="Checkout"
							/>
							<FormControlLabel
								value="both"
								control={<Radio color="primary" />}
								label="Both"
							/>
						</RadioGroup>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						<CustomButton
							style={{
								padding: "8px",
								// backgroundColor: "#fff",
								// color: "#000",
								minWidth: "100px",   // ← Add this
							}}
							variant="contained"
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						{/* <Button
							style={{
								backgroundColor: "#00b9f5",
								color: "white"
							}}
							variant="contained"
							onClick={addOrUpdateIntegrationReq}
						>
							Add
						</Button> */}
						<CustomButton
							style={{
								padding: "8px",
								minWidth: "100px",   // ← Add this
							}}
							onClick={addOrUpdateIntegrationReq}
						// endIcon={<SaveIcon />}
						>
							Add
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			<div>
				<Dialog open={editOpen} onClose={handleClose}>
					<DialogTitle>Edit Integration</DialogTitle>
					<DialogContent>
						{/* <TextField
              required
              select
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Wallet Owner ID"
              fullWidth={true}
              name="walletOwnerID"
              defaultValue={walletOwnerID || "Select Owner Id"}
              onChange={(e) => onInputChange(e)}
            >
              <MenuItem value="Select Owner Id" selected="Select Owner Id">
                Select Owner Id
              </MenuItem>
              {getWalletOwnerIdRes.data.ownerList &&
                getWalletOwnerIdResArray.map((x) => (
                  <MenuItem value={x}>{x}</MenuItem>
                  // <MenuItem value={x.replace(/[0-9]/g, "").replace("-", "")}>
                  //   {x.replace(/[0-9]/g, "").replace("-", "")}
                  // </MenuItem>
                ))}
            </TextField> */}

						<TextField
							// required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Integration Type"
							fullWidth={true}
							name="integrationType"
							value={integrationType || ""}  // ✅ controlled, reacts to state
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						>
							<MenuItem value="All" selected="All">
								Select Integration Type
							</MenuItem>
							{getIntegrationTypeListRes.data.integrationTypeList &&
								getIntegrationTypeArray.map((x) => (
									<MenuItem key={x} value={x}>  {/* ✅ raw value matches API */}
										{x.replace(/_/g, " ")}    {/* display label uses spaces */}
									</MenuItem>
								))}
						</TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Integration Name"
							fullWidth={true}
							name="integrationName"
							value={integrationName || ""}
							//   onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member User Name/Number"
							fullWidth={true}
							name="memberUserName"
							value={memberUserName || ""}
							onChange={(e) => onInputChange(e)}
							// onChange={(e) => onInputChange(e, "both")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member ID/SID"
							fullWidth={true}
							name="memberID"
							value={memberID || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "number")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>
						{/* 
						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member Secret Key"
							fullWidth={true}
							name="memberSecretKey"
							value={memberSecretKey || ""}
							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Currency"
							fullWidth={true}
							name="currency"
							// defaultValue={currency || "All"}
							value={currency || ""}

							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						> */}
						{/* <MenuItem value="All" selected="All">
								Select Currency
							</MenuItem>
							{adminCurrencyList.success &&
								[]
									.concat(adminCurrencyList.data.currencyList)
									.map((x) => <MenuItem value={x}>{x}</MenuItem>)} */}
						{/* </TextField> */}

						{/* <TextField
							required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Currency"
							fullWidth={true}
							name="Currency"
							// value={currency || "All"}
							onChange={(e) => onInputChange(e)}
							// onChange={(e) => onInputChange(e, "both")}


							defaultValue={currency || "All"}

							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						>



							<MenuItem value="All" selected="All">
								Select Currency
							</MenuItem>
							{adminCurrencyList.success &&
								[]
									.concat(adminCurrencyList.data.currencyList)
									.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
						</TextField> */}

						<FormControl style={{ width: '100%', marginTop: '10px' }}>
							<InputLabel id='editMultipleCurrencySelect' sx={{ color: 'gray' }}>
								Select Currency
							</InputLabel>
							<Select
								labelId='editMultipleCurrencySelect'
								multiple
								fullWidth={true}
								variant='standard'
								value={currencies || []}
								input={<Input />}
								renderValue={selected => selected.join(', ')}
								onChange={(e) => {
									const value = e.target.value;
									if (value.includes('all')) {
										const allCurrencies = adminCurrencyList.success
											? [].concat(adminCurrencyList.data.currencyList)
											: [];
										setCurrencies(
											currencies.length === allCurrencies.length
												? []
												: allCurrencies
										);
									} else {
										setCurrencies(value);
									}
								}}
								name='currencies'
								sx={{
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								}}
							>
								<MenuItem key='all' value='all'>
									<Checkbox color='primary'
										checked={
											adminCurrencyList.success &&
											currencies.length === [].concat(adminCurrencyList.data.currencyList).length
										}
									/>
									<ListItemText primary='Select All' />
								</MenuItem>
								{adminCurrencyList.success &&
									[].concat(adminCurrencyList.data.currencyList).map((x, index) => (
										<MenuItem key={index} value={x}>
											<Checkbox color='primary'
												checked={currencies.indexOf(x) > -1} />
											<ListItemText primary={x} />
										</MenuItem>
									))
								}
							</Select>
						</FormControl>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner ID"
							fullWidth={true}
							name="partnerID"
							value={partnerID || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "number")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Terminal ID"
							fullWidth={true}
							name="terminalID"
							value={terminalID || ""}
							//   onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "number")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="To Type"
							fullWidth={true}
							name="toType"
							value={toType || ""}
							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Redirect URL"
							fullWidth={true}
							name="redirectURL"
							value={redirectURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Type"
							fullWidth={true}
							name="paymentType"
							value={paymentType || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							//onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Brand"
							fullWidth={true}
							name="paymentBrand"
							value={paymentBrand || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Mode"
							fullWidth={true}
							name="paymentMode"
							value={paymentMode || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "alphabet")}
						></TextField>
						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Transaction URL"
							fullWidth={true}
							name="transactionURL"
							value={transactionURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							onChange={(e) => onInputChange(e)}
						//onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="CheckOut Transaction URL"
							fullWidth={true}
							name="checkOutTransactionURL"
							value={checkOutTransactionURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						//onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="WithDraw URL"
							fullWidth={true}
							name="withDrawURL"
							value={withDrawURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="AuthToken URL"
							fullWidth={true}
							name="authTokenURL"
							value={authTokenURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						//onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Deposit URL"
							fullWidth={true}
							name="depositeURL"
							value={depositeURL || ""}
							onChange={(e) => onInputChange(e)}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Refund URL"
							fullWidth={true}
							name="refundURL"
							value={refundURL || ""}
							onChange={(e) => onInputChange(e)}

							// onChange={(e) => setUser(prev => ({ ...prev, isRefund: e.target.value }))}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						// onChange={(e) => onInputChange(e, "url")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner Key"
							fullWidth={true}
							name="partnerKey"
							value={partnerKey || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

							//  onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
						></TextField>

						<TextField
							// required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner User Name"
							fullWidth={true}
							name="partnerUserName"
							value={partnerUserName || ""}
							// onChange={(e) => onInputChange(e)}
							onChange={(e) => onInputChange(e, "both")}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							select
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
               Is Active"
							fullWidth
							name="isActive"
							value={isActive || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>

						{/* After isActive TextField in EDIT dialog */}
						<TextField
							select
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"
							label="Is Refund"
							fullWidth
							name="isRefund"
							value={isRefund || ""}
							onChange={(e) => onInputChange(e, "both")}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' },
							}}
						>
							<MenuItem value="Auto">Auto</MenuItem>
							<MenuItem value="Manual">Manual</MenuItem>
						</TextField>


						<TextField
							select
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
									   Is Test"
							fullWidth
							name="isTest"
							value={isTest || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>


						<TextField
							select
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
									   IS Address"
							fullWidth
							name="isAddress"
							value={isAddress || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>


						<FormControl style={{ width: '100%', marginTop: '10px' }}>
							<InputLabel id='editMultipleCountrySelect' sx={{ color: 'gray' }}>
								Select Countries
							</InputLabel>
							<Select
								labelId='editMultipleCountrySelect'
								multiple
								fullWidth={true}
								variant='standard'
								value={countries || []}
								input={<Input />}
								renderValue={selected => selected.join(', ')}
								onChange={(e) => {
									const value = e.target.value;
									if (value.includes('all')) {
										setCountries(
											countries.length === countryList.filter(ch => !ch.disabled).length
												? []
												: countryList.filter(ch => !ch.disabled).map(x => x.countryName)
										);
									} else {
										setCountries(value);
									}
								}}
								name='countries'
								sx={{
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								}}
							>
								<MenuItem key='all' value='all'>
									<Checkbox color='primary'
										checked={countries.length === countryList.filter(ch => !ch.disabled).length} />
									<ListItemText primary='Select All' />
								</MenuItem>
								{countryList &&
									[].concat(countryList).map((x, index) => {
										return (
											<MenuItem key={index}
												disabled={x.disabled}
												value={`${x.countryName}`}>
												<Checkbox color='primary'
													checked={countries.indexOf(`${x.countryName}`) > -1} />
												<ListItemText primary={x.countryName} />
											</MenuItem>
										)
									})
								}
							</Select>
						</FormControl>

						<FormLabel style={{ marginBottom: "0", marginTop: "12px" }}>
							Integration
						</FormLabel>
						<RadioGroup
							required
							row
							name="integration"
							value={integration || ""}
							onChange={(e) => onInputChange(e)}
						>
							<FormControlLabel
								value="api"
								control={<Radio color="primary" />}
								label="Api"
							/>
							<FormControlLabel
								value="checkout"
								control={<Radio color="primary" />}
								label="Checkout"
							/>
							<FormControlLabel
								value="both"
								control={<Radio color="primary" />}
								label="Both"
							/>
						</RadioGroup>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						<CustomButton
							style={{
								padding: "8px"
							}}

							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						{/* <Button
							style={{
								backgroundColor: "#00b9f5",
								color: "white"
							}}
							variant="contained"
							onClick={addOrUpdateIntegrationReq}
						>
							Edit
						</Button> */}
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={addOrUpdateIntegrationReq}
						>
							Edit
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			<div>
				<Dialog open={viewOpen} onClose={handleClose}>
					<DialogTitle>View Integration</DialogTitle>
					<DialogContent>
						{/* <TextField
              disabled
              required
              select
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Wallet Owner ID"
              fullWidth={true}
              name="walletOwnerID"
              defaultValue={walletOwnerID || "Select Owner Id"}
            >
              <MenuItem value="Select Owner Id" selected="Select Owner Id">
                Select Owner Id
              </MenuItem>
              {getWalletOwnerIdRes.data.ownerList &&
                getWalletOwnerIdResArray.map((x) => (
                  <MenuItem value={x.replace(/[0-9]/g, "").replace("-", "")}>
                    {x.replace(/[0-9]/g, "").replace("-", "")}
                  </MenuItem>
                ))}
            </TextField> */}

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Integration Type"
							fullWidth={true}
							name="integrationType"
							variant="standard"
							value={integrationType || ""}  // ✅
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="All" selected="All">
								Select Integration Type
							</MenuItem>
							{getIntegrationTypeListRes.data.integrationTypeList &&
								getIntegrationTypeArray.map((x) => (
									<MenuItem key={x} value={x}>  {/* ✅ raw value */}
										{x.replace(/_/g, " ")}
									</MenuItem>
								))}
						</TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Integration Name"
							fullWidth={true}
							name="integrationName"
							variant="standard"

							value={integrationName || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member User Name/Number"
							fullWidth={true}
							name="memberUserName"
							variant="standard"

							value={memberUserName || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member ID/SID"
							fullWidth={true}
							name="memberID"
							value={memberID || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member Secret Key"
							fullWidth={true}
							name="memberSecretKey"
							value={memberSecretKey || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						{/* <TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							select
							size="small"
							color="primary"
							type="text"
							label="Currency"
							fullWidth={true}
							name="currency"
							defaultValue={currency || "All"}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						>
							<MenuItem value="All" selected="All">
								Select Currency
							</MenuItem>
							{adminCurrencyList.success &&
								[]
									.concat(adminCurrencyList.data.currencyList)
									.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
						</TextField> */}

						<FormControl style={{ width: '100%', marginTop: '10px' }}>
							<InputLabel id='viewMultipleCurrencySelect' sx={{ color: 'gray' }}>
								Currency
							</InputLabel>
							<Select
								disabled
								labelId='viewMultipleCurrencySelect'
								multiple
								fullWidth={true}
								variant='standard'
								value={currencies || []}
								input={<Input />}
								renderValue={selected => selected.length > 0 ? selected.join(', ') : 'No currency selected'}
								name='currencies'
								sx={{
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								}}
							>
								{adminCurrencyList.success &&
									[].concat(adminCurrencyList.data.currencyList).map((x, index) => (
										<MenuItem key={index} value={x} disabled>
											<Checkbox color='primary' disabled
												checked={currencies.indexOf(x) > -1} />
											<ListItemText primary={x} />
										</MenuItem>
									))
								}
							</Select>
						</FormControl>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner ID"
							fullWidth={true}
							name="partnerID"
							value={partnerID || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Terminal ID"
							fullWidth={true}
							name="terminalID"
							value={terminalID || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="To Type"
							fullWidth={true}
							name="toType"
							value={toType || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Redirect URL"
							fullWidth={true}
							name="redirectURL"
							value={redirectURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Type"
							fullWidth={true}
							name="paymentType"
							value={paymentType || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Brand"
							fullWidth={true}
							name="paymentBrand"
							value={paymentBrand || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Payment Mode"
							fullWidth={true}
							name="paymentMode"
							value={paymentMode || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>
						<TextField
							disabled
							required
							style={{ marginTop: "10px", textOverflow: "ellipsis" }}
							size="small"
							color="primary"
							type="text"
							label="Transaction URL"
							fullWidth={true}
							name="transactionURL"
							value={transactionURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="CheckOut Transaction URL"
							fullWidth={true}
							name="checkOutTransactionURL"
							value={checkOutTransactionURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="WithDraw URL"
							fullWidth={true}
							name="withDrawURL"
							value={withDrawURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="AuthToken URL"
							fullWidth={true}
							name="authTokenURL"
							value={authTokenURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Deposit URL"
							fullWidth={true}
							name="depositeURL"
							value={depositeURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Refund URL"
							fullWidth={true}
							name="refundURL"
							value={refundURL || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner Key"
							fullWidth={true}
							name="partnerKey"
							value={partnerKey || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner User Name"
							fullWidth={true}
							name="partnerUserName"
							value={partnerUserName || ""}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						></TextField>
						<TextField
							select
							disabled

							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
               Is Active"
							fullWidth
							name="isActive"
							value={isActive || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>

						{/* After isActive TextField in VIEW dialog */}
						<TextField
							disabled
							select
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"
							label="Is Refund"
							fullWidth
							name="isRefund"
							value={isRefund || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' },
							}}
						>
							<MenuItem value="Auto">Auto</MenuItem>
							<MenuItem value="Manual">Manual</MenuItem>
						</TextField>

						<TextField
							select
							disabled

							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
									   Is Test"
							fullWidth
							name="isTest"
							value={isTest || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>

						<TextField
							select
							disabled
							// autoFocus
							margin="dense"
							variant="standard"
							style={{ marginTop: "10px" }}
							size="small"

							label="
									   Is Address"
							fullWidth
							name="isAddress"
							value={isAddress || ""}
							onChange={(e) => onInputChange(e, "both")}

							// onChange={handleChange}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						>
							<MenuItem value="Y">Y </MenuItem>
							<MenuItem value="N">N </MenuItem>

						</TextField>


						{/* Countries Multi-Select - DISABLED for View */}
						<FormControl style={{ width: '100%', marginTop: '10px' }}>
							<InputLabel id='viewMultipleCountrySelect' sx={{ color: 'gray' }}>
								Selected Countries
							</InputLabel>
							<Select
								disabled
								labelId='viewMultipleCountrySelect'
								multiple
								fullWidth={true}
								variant='standard'
								value={countries || []}
								input={<Input />}
								renderValue={selected => selected.length > 0 ? selected.join(', ') : 'No countries selected'}
								name='countries'
								sx={{
									"&:before": { borderBottomColor: "gray" },
									"&:after": { borderBottomColor: "gray" },
								}}
							>
								<MenuItem key='all' value='all' disabled>
									<Checkbox color='primary' disabled
										checked={countries.length === countryList.filter(ch => !ch.disabled).length} />
									<ListItemText primary='Select All' />
								</MenuItem>
								{countryList &&
									[].concat(countryList).map((x, index) => {
										return (
											<MenuItem key={index}
												disabled
												value={`${x.countryName}`}>
												<Checkbox color='primary' disabled
													checked={countries.indexOf(`${x.countryName}`) > -1} />
												<ListItemText primary={x.countryName} />
											</MenuItem>
										)
									})
								}
							</Select>
						</FormControl>


						<FormLabel style={{ marginBottom: "0", marginTop: "12px" }}>
							Integration
						</FormLabel>
						<RadioGroup
							disabled
							required
							row
							name="integration"
							value={integration || ""}
							onChange={(e) => onInputChange(e)}
						>
							<FormControlLabel
								disabled
								value="api"
								control={<Radio color="primary" />}
								label="Api"
							/>
							<FormControlLabel
								disabled
								value="checkout"
								control={<Radio color="primary" />}
								label="Checkout"
							/>
							<FormControlLabel
								disabled
								value="both"
								control={<Radio color="primary" />}
								label="Both"
							/>
						</RadioGroup>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						{/* <Button
							style={{
								backgroundColor: "#00b9f5",
								color: "white"
							}}
							variant="contained"
							onClick={handleClose}
						>
							Close
						</Button> */}
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Close
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			{deleteIntegrationArray.status == "success" && (
				<div>
					<Dialog open={notificationDeleteOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteIntegrationArray.status == "failed" && (
				<div>
					<Dialog open={notificationDeleteOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateIntegrationArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateIntegrationArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateIntegrationArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminGatewayManagement;
